(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gemz-product-videos"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const closeButton = event.target.closest('.gemz-product-videos [data-video-close]');
  if (closeButton) {
    closeButton.closest('dialog').close();
    return;
  }
  const button = event.target.closest('.gemz-product-videos [data-video-url]');
  if (!button) return;
  const dialog = button.closest('.gemz-product-videos').querySelector('dialog');
  const player = dialog.querySelector('video');
  dialog.addEventListener('close', () => {
    player.pause();
    player.removeAttribute('src');
    player.load();
    button.focus();
  }, { once: true });
  player.src = button.dataset.videoUrl;
  dialog.showModal();
  player.play().catch(() => {});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gemz-sharing-consent"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gemz-cart-sharing')) {
  customElements.define('gemz-cart-sharing', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.checkbox = this.querySelector('[data-sharing-choice]');
      this.no = this.querySelector('[data-sharing-no]');
      this.notice = this.querySelector('[data-sharing-notice]');
      this.status = this.querySelector('[data-sharing-status]');
      this.form = this.closest('form');
      this.pending = 0;
      this.queue = Promise.resolve();
      this.onChange = () => {
        this.no.disabled = this.checkbox.checked;
        const attributes = {
          'Sharing permission': this.checkbox.checked ? this.checkbox.value : 'No',
          'Sharing permission wording v1': this.notice.value
        };
        this.pending += 1;
        this.form.setAttribute('data-gemz-saving', '');
        this.status.hidden = true;
        this.queue = this.queue.then(async () => {
          try {
            const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
              method: 'POST',
              headers: {'Content-Type': 'application/json'},
              body: JSON.stringify({attributes})
            });
            if (!response.ok) throw new Error('Save failed');
            this.status.hidden = true;
          } catch (error) {
            this.status.textContent = this.dataset.saveError;
            this.status.hidden = false;
          } finally {
            this.pending -= 1;
            if (!this.pending) this.form.removeAttribute('data-gemz-saving');
          }
        });
      };
      this.onSubmit = async (event) => {
        if (!this.pending) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const submitter = event.submitter;
        while (this.pending) await this.queue;
        if (submitter?.isConnected) this.form.requestSubmit(submitter);
        else this.form.requestSubmit();
      };
      this.checkbox.addEventListener('change', this.onChange);
      this.form.addEventListener('submit', this.onSubmit, true);
    }
    disconnectedCallback() {
      this.checkbox?.removeEventListener('change', this.onChange);
      this.form?.removeEventListener('submit', this.onSubmit, true);
      this.initialized = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
